import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import {  Apitoken, Authtoken  } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
// import { Inbox } from "@material-ui/icons";

const Editcontract = () => {
  let { id } = useParams();
  const [value, setValue] = useState({});
  const [productLists, setproductLists] = useState([]);
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [customerNames, setcustomerNames] = useState([]);
  const [permission, setPermission] = useState({});



  useEffect(() => {
        setPermission(FindModuleById(452)); 
      console.log(permission);

    axios
      .get(`/contracts/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
         // toast.error(response.data.data.order);
          setValue(response.data.data.contract);
          
          
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
  
  const formik = useFormik({
    initialValues: {
      id: value.id,
       customer: value.customer,
      contract_number: value.contract_number,
      product: value.product,
      quantity: value.quantity,
      price: value.price,
      status : value.status,
      file : value.file,
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/contracts/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Update Contract"); 
         delete backendErrors['error'];
         //  actions.setSubmitting(false);
          setSubmitting(false);
           if (response.data.code === 200) {
             //setBackendSuccess(response.data.message);
             toast.success(response.data.message);
            // actions.resetForm();
             setTimeout(() => {
               window.location.href = "/contracts";
             }, 500);
           }  else if (response.data.code === 422) {
               setBackendErrors(response.data.error);
           }
           else if (response.data.code === 401) {
             setBackendErrors(response.data.error);
           }
           else {
              setBackendErrors(response.data.error);
           }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {


    axios.post("/helpers/get-all-customers", {}, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
    .then((response) => {
     // let customers = response.data.data.customers;
      if (response.data.code === 200) {
        let shipping_methods = response.data.data.customers;
        let customerOptions = shipping_methods.map((customer, index) => ({
          label: customer.company_name,
          value: customer.id,
          key: `customer-${index}`,
        }));
        setcustomerNames(customerOptions);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
    axios .post( "/products/listing-category-type", {}, {  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, }
      ).then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          let productslisting = products.map((customer, index) => ({
            label: customer.productname ,
            value: customer.id,
            key: `address-${index}`,
          }));
          setproductLists(productslisting);
         
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
   
  }, []);
  const exportatornumber = [
    { value: '1', label: "Confirmed" },
    { value: '2', label: "Finished" },
    { value: '3', label: "In Process" },
    { value: '4', label: "Draft" } ,
    { value: '5', label: "Cancelled" }
  ];
  
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />  <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Contracts</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/contracts">
                      Contracts
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Edit Contract
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission && permission.update === 1 && (
                    <div className="card-body">
                      <h4 className="card-title">Edit Contract</h4>
                     <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                  <label>Contract Number</label> 
                                  <input
                                    type="text"
                                   
                                    placeholder="Enter Contract Number"
                                    className="form-input form-control"
                                    name="contract_number"
                                    value={formik.values.contract_number}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                   
                                    }}
                                    onBlur={formik.handleBlur}
                                  
                                  />
                                  <small>
                                    {backendErrors.contract_number && (
                                        <span className="form-error mt-1">
                                          {backendErrors.contract_number}
                                        </span>
                                      )}
                                  </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Customer</label>
                                  <Select
                                    className="w-100"
                                    value={customerNames.find(option => option.value == formik.values.customer) || null} // Ensure correct format
                                    name="customer"
                                    onChange={(selectedOption) => {
                                      handleSelectChange("customer", selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={customerNames}
                                    placeholder="Select"
                                 />

                                <small>
                                  {backendErrors.customer && (
                                    <span className="form-error mt-1">
                                      {backendErrors.customer}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                                <div className="col-md-6">
                                  <div className="form-group status">
                                      <label>Product</label>
                                      <Select
                                      className="w-100"
                                      value={productLists.find(option => option.value == formik.values.product) || null} // Ensure correct format
                                      name="product"
                                      onChange={(selectedOption) => {
                                        handleSelectChange("product", selectedOption);
                                        // handleGetAddressByCustomer(selectedOption);
                                      }}
                                      onBlur={formik.handleBlur}
                                      options={productLists}
                                      placeholder="Select"
                                  
                                      />
                                  
                                      <small>
                                        {backendErrors.product && (
                                          <span className="form-error mt-1">
                                            {backendErrors.product}
                                          </span>
                                        )}
                                      </small>
                                    </div>
                                </div>
                           
                           <div className="col-md-6">
                              <div className="form-group">
                                  <label>Price</label> 
                                  <input
                                    type="text"
                                   
                                    className="form-input form-control"
                                    name="price"
                                    value={formik.values.price}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    onKeyPress={(event) => {
                                    if (!/^[0-9.]$/.test(event.key) || (event.key === "." && event.target.value.includes("."))) {
                                      event.preventDefault();
                                    }
                                  }}
                                  
                                  />
                                  <small>
                                    {backendErrors.price && (
                                        <span className="form-error mt-1">
                                          {backendErrors.price}
                                        </span>
                                      )}
                                  </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                  <label>Quanitity</label> 
                                  <input
                                    type="text"
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9]$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    className="form-input form-control"
                                    name="quantity"
                                    value={formik.values.quantity}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  
                                  />
                                  <small>
                                    {backendErrors.quantity && (
                                        <span className="form-error mt-1">
                                          {backendErrors.quantity}
                                        </span>
                                      )}
                                  </small>
                              </div>
                            </div>
                              <div className="col-md-6">
                                  <div className="form-group status">
                                      <label>Status</label>
                                      <Select
                                      className="w-100"
                                      value={exportatornumber.find(option => option.value == formik.values.status) || null} // Ensure correct format
                                      name="status"
                                      onChange={(selectedOption) => {
                                        handleSelectChange("status", selectedOption);
                                        // handleGetAddressByCustomer(selectedOption);
                                      }}
                                      onBlur={formik.handleBlur}
                                      options={exportatornumber}
                                      placeholder="Select"
                                  
                                      />
                                  
                                      <small>
                                        {backendErrors.status && (
                                          <span className="form-error mt-1">
                                            {backendErrors.status}
                                          </span>
                                        )}
                                      </small>
                                    </div>
                                </div>

                                 <div className="col-md-6">
                            <div className="form-group status">
                                <label>PDF</label>
                              
                                    <input
                                      className="form-control"
                                      type="file"
                                      name="file"
                                      onChange={(event) => {
                                        const file_link = event.target.files[0];
                                        //console.log("file:", file_link);
                                        //const fileName = file_link.name;
                                       // const fileName = file_link.name;
                                        const reader = new FileReader();

                                        reader.onloadend = () => {
                                          formik.setFieldValue(
                                            "file",
                                            reader.result
                                          );
                                        };
      
                                        if (file_link) {
                                          reader.readAsDataURL(file_link);
                                        }
                                      }}
                                    />
                                  
                              <small>
                                  {backendErrors.file && (
                                      <span className="form-error mt-1">
                                        {backendErrors.file}
                                      </span>
                                    )}
                                </small>
                              </div>
                            </div>
                          </div>
                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                                Update Contract 
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Editcontract;
